import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { DeactivateAccountModal, DeactivateAccountWidgetStep } from './types';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';

export const setDeactivateAccountWidgetStep = createAction(
  `${reduxKey}.SET_DEACTIVATEACCOUNT_WIDGET_STEP`,
  (step: DeactivateAccountWidgetStep) => ({ step })
);

export const pushSendVerificationEmailModal = () =>
  pushModal(DeactivateAccountModal.SendVerificationEmail, {
    wrapInModal: false,
  });

export const submitSendVerificationEmailModal = createAction(
  `${reduxKey}.SUBMIT_SEND_VERIFICATION_EMAIL_MODAL`,
  (password: string) => ({ password })
);

export const submitSendVerificationEmailModalSuccess = createAction(
  `${reduxKey}.SUBMIT_SEND_VERIFICATION_EMAIL_MODAL_SUCCESS`,
  () => ({})
);

export const submitSendVerificationEmailModalFailure = createAction(
  `${reduxKey}.SUBMIT_SEND_VERIFICATION_EMAIL_MODAL_FAILURE`,
  (error: string) => ({ error })
);

export const pushConfirmDeactivationModal = () =>
  pushModal(DeactivateAccountModal.ConfirmDeactivation, {
    wrapInModal: false,
  });

export const submitConfirmDeactivationModal = createAction(
  `${reduxKey}.SUBMIT_CONFIRM_DEACTIVATION_MODAL`,
  (reason: string, detail: string) => ({ reason, detail })
);

export const submitConfirmDeactivationModalSuccess = createAction(
  `${reduxKey}.SUBMIT_CONFIRM_DEACTIVATION_MODAL_SUCCESS`,
  () => ({})
);

export const submitConfirmDeactivationModalFailure = createAction(
  `${reduxKey}.SUBMIT_CONFIRM_DEACTIVATION_MODAL_FAILURE`,
  (error: string) => ({ error })
);

export const submitReactivate = createAction(
  `${reduxKey}.SUBMIT_REACTIVATE`,
  (password: string) => ({
    password,
  })
);

export const submitReactivateSuccess = createAction(
  `${reduxKey}.SUBMIT_REACTIVATE_SUCCESS`,
  () => ({})
);

export const submitReactivateFailure = createAction(
  `${reduxKey}.SUBMIT_REACTIVATE_FAILURE`,
  (error: string) => ({ error })
);
